module.exports = {
  "/": {},
  "/crm": {
    "success": {
      "default": [
        "FREE_TOOLS_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "freePage"
  },
  "/bundle": {
    "success": {
      "default": [
        "BUNDLE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "bundlePage"
  },
  "/marketing": {
    "success": {
      "default": [
        "MARKETING_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPage"
  },
  "/sales": {
    "success": {
      "default": [
        "SALES_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "salesPage"
  },
  "/service": {
    "success": {
      "default": [
        "SERVICE_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "servicePage"
  },
  "/content": {
    "success": {
      "default": [
        "CONTENT_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "contentPage"
  },
  "/data": {
    "success": {
      "default": [
        "DATA_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "dataPage"
  },
  "/commerce": {
    "success": {
      "default": [
        "COMMERCE_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "commercePage"
  },
  "/revenue": {
    "success": {
      "default": [
        "COMMERCE_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "revenuePage"
  },
  "/suite": {
    "success": {
      "default": [
        "CUSTOMER_PLATFORM_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suitePage"
  },
  "/marketing-plus": {
    "success": {
      "default": [
        "MARKETING_PLUS_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPlusPage"
  },
  "/smart-crm": {
    "success": {
      "default": [
        "SMART_CRM_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "smartCrmPage"
  },
  "/hubspot-credits": {}
};